import { render, staticRenderFns } from "./BrandCard.vue?vue&type=template&id=6c834d22&scoped=true&"
import script from "./BrandCard.vue?vue&type=script&lang=js&"
export * from "./BrandCard.vue?vue&type=script&lang=js&"
import style0 from "./BrandCard.vue?vue&type=style&index=0&id=6c834d22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c834d22",
  null
  
)

export default component.exports